/**
 * Les vignettes promo du tiroir sont en `loading="lazy"` dans des panneaux `display: none` :
 * sans boite de rendu, le navigateur ne les demande qu'a l'ouverture du panneau, d'ou l'attente
 * visible a la premiere consultation du menu. On bascule en `eager` des que la main se pose sur
 * le bouton du menu : le telechargement couvre l'animation d'ouverture et la lecture du premier
 * niveau. Tant que le menu n'est pas approche, rien n'est telecharge.
 */
(() => {
  const warm = (event) => {
    if (!event.target.closest?.('[aria-controls="menu-drawer"]')) return;

    document.querySelectorAll('#menu-drawer .menu-promo img[loading="lazy"]').forEach((image) => {
      image.loading = 'eager';
    });

    document.removeEventListener('pointerdown', warm, true);
    document.removeEventListener('focusin', warm, true);
  };

  document.addEventListener('pointerdown', warm, true);
  document.addEventListener('focusin', warm, true);
})();
